module.exports = __webpack_public_path__ + "img/bathroom.4faaef62.jpg";